import type { FC } from 'react';
import React from 'react';
import classNames from 'classnames';

import type { TLabel } from './models';

export const Label: FC<React.PropsWithChildren<TLabel>> = ({
    children,
    className,
    leftPlace,
    rightPlace,
    styles,
    ...rest
}) => {
    return (
        // eslint-disable-next-line jsx-a11y/label-has-for
        <label className={classNames(styles.label, className)} {...rest}>
            {leftPlace && <div className={styles.sidePlace}>{leftPlace}</div>}
            <div className={styles.inputPlace}>{children}</div>
            {rightPlace && <div className={styles.sidePlace}>{rightPlace}</div>}
        </label>
    );
};
